module.exports = __webpack_public_path__ + "static/media/17122min.eb994a70.jpg";